import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { JsonKeyCode } from '../data/type/locale-copy-key';
import { Locale, LocaleCode } from '../data/type/locale';
import { RoutePath } from 'src/app/app-routing.module';
import { Router } from '@angular/router';
import { AudioResponseKey } from 'src/app/data/enum/audio-response';
import { environment } from 'src/environments/environment';

@Injectable()
export class LocalizationService {
  private _jsonFileData: Record<JsonKeyCode, string>;
  private currentLocale: LocaleCode = Locale['en-us'];

  constructor(private httpClient: HttpClient, private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
  }

  public translationLoaded$: EventEmitter<boolean> = new EventEmitter();

  public getLocalizedCopy(localeCode: LocaleCode) {
    this.currentLocale = localeCode as LocaleCode;
    this.httpClient
      .get(`${environment.baseHref}/assets/translation/${localeCode}.json`)
      .subscribe((jsonFileData: Record<JsonKeyCode, string>) => {
        this._jsonFileData = jsonFileData;
        this.translationLoaded$.emit(true);
      });
  }

  public getLocalizedAudio(fileName: AudioResponseKey) {
    return `${environment.baseHref}/assets/audio/${this.currentLocale}/${fileName}.mp3`;
  }

  public getLocalizedLink(routePath: keyof typeof RoutePath) {
    return `/${this.currentLocale}/${routePath}`;
  }

  public localizedNavigate(routePath: keyof typeof RoutePath) {
    this.router.navigate([`/${this.currentLocale}/${routePath}`], {
      queryParamsHandling: 'preserve',
    });
  }

  public translate(key: JsonKeyCode) {
    return this._jsonFileData[key] || 'key not found';
  }
}
